import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import MessageDialog from 'src/components/MessageDialog';

import * as Actions from '../actions/questionnaireList';
import { IUserAttr } from '../actions/session';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ImstatScenarioFactory from '../scenario/ImstatScenarioFactory';
import ScenarioFactory, {
	IFetchQuestionnaireParam,
} from '../scenario/QuestionnaireListScenarioFactory';
import { isValid, MasterItemCode } from '../utils/MasterData';
import { Routes, Screens } from '../utils/Routes';

const styles = (theme: Theme) =>
	createStyles({
		paper: {
			marginTop: theme.spacing(4),
			padding: theme.spacing(3),
		},
		root: {
			flexGrow: 1,
			padding: theme.spacing(3),
		},
		tableCell: {
			minWidth: '170px',
		},
	});

interface IRouteParams {
	career_id: string;
	class_id: string;
}

// tslint:disable-next-line: no-empty-interface
interface IRouteState {}

interface IState {
	careerTitle: string;
	classTitle: string;
	errorStudyOrderdialogContent: string;
	errorStudyOrderdialogReplaceContent: string[];
	openErrorStudyOrderMessageDialog: boolean;
}

/**
 * アンケート一覧
 */
class QuestionnaireList extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);

		this.state = {
			careerTitle: '',
			classTitle: '',
			errorStudyOrderdialogContent: '',
			errorStudyOrderdialogReplaceContent: [],
			openErrorStudyOrderMessageDialog: false,
		};
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		window.scrollTo({
			top: 0,
		});
		if (!this.props.match || !this.props.match.params) {
			return;
		}

		const careerID = this.props.match.params.career_id;
		const classID = this.props.match.params.class_id;

		// アンケート一覧取得
		this.props.fetchQuestionnaireList(this.props.token, {
			careerID,
			classID,
			userAttr: this.props.userAttr,
		});

		// 一覧からタイトルを探す処理を定義
		interface IClass {
			careerID: string;
			classID: string;
			careerTitle: string;
			classTitle: string;
		}
		const setTitle = (classes: IClass[]) => {
			for (const c of classes) {
				if (c.careerID === careerID && c.classID === classID) {
					this.setState({
						careerTitle: c.careerTitle,
						classTitle: c.classTitle,
					});
					return true;
				}
			}
			return false;
		};

		// 一覧から受講順項目を探す処理を定義
		interface IStudyOrderClass {
			careerID: string;
			classID: string;
			uncompletedCareers: string;
			unrepresentedCareerCnt: string;
		}
		const setStudyOrderChkMsg = (classes: IStudyOrderClass[]) => {
			for (const c of classes) {
				if (c.careerID === careerID && c.classID === classID) {
					if (
						c.uncompletedCareers !== null &&
						c.uncompletedCareers !== ''
					) {
						if (c.unrepresentedCareerCnt !== '0') {
							this.setState({
								errorStudyOrderdialogContent: 'LMCM_E_15513',
							});
							this.setState({
								errorStudyOrderdialogReplaceContent: [
									c.uncompletedCareers,
									c.unrepresentedCareerCnt,
								],
							});
						} else {
							this.setState({
								errorStudyOrderdialogContent: 'LMCM_E_15512',
							});
							this.setState({
								errorStudyOrderdialogReplaceContent: [
									c.uncompletedCareers,
								],
							});
						}
					}
				}
			}
		};

		if (this.props.eLearnings.length > 0) {
			// imstatのeラーニング一覧があればそこから探す
			if (setTitle(this.props.eLearnings)) {
				setStudyOrderChkMsg(this.props.eLearnings);
				return;
			}
		}
		const isGD = isValid(MasterItemCode.CAREER_TYPE_CONTROL); // 集合研修/通信教育オプション
		if (isGD) {
			if (this.props.groupTrainings.length > 0) {
				// imstatの集合研修一覧があればそこから探す
				if (setTitle(this.props.groupTrainings)) {
					return;
				}
			}
			if (this.props.distanceLearnings.length > 0) {
				// imstatの通信教育一覧があればそこから探す
				if (setTitle(this.props.distanceLearnings)) {
					return;
				}
			}
		}

		// imstatの一覧にない場合は自分で取得してから探す
		this.props
			.doFetchOnGoingELearning(this.props.token, this.props.userAttr)
			.then(eLearnings => {
				if (setTitle(eLearnings) || !isGD) {
					setStudyOrderChkMsg(eLearnings);
					return;
				}
				this.props
					.doFetchOnGoingGroupTraining(
						this.props.token,
						this.props.userAttr
					)
					.then(groupTrainings => {
						if (setTitle(groupTrainings)) {
							return;
						}
						this.props
							.doFetchOnGoingDistanceLearning(
								this.props.token,
								this.props.userAttr
							)
							.then(distanceLearnings => {
								if (setTitle(distanceLearnings)) {
									return;
								}
								this.props
									.doFetchResultGroupTraining(
										this.props.token,
										this.props.userAttr
									)
									.then(g => {
										if (setTitle(g)) {
											return;
										}
										this.props
											.doFetchResultDistanceLearning(
												this.props.token,
												this.props.userAttr
											)
											.then(d => {
												setTitle(d);
											});
									});
							});
					});
			});
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		this.props.clearQuestionnaireParams();
	}

	public render() {
		const { classes } = this.props;

		return (
			<div className={classes.root}>
				<Grid container={true} spacing={2} alignItems="flex-end">
					<Grid item={true} xs={12} md={2}>
						<Typography variant="subtitle1">
							{i18n.t('QuestionnaireList_0001')}
						</Typography>
					</Grid>
					<Grid item={true}>
						<Typography variant="h6">
							{this.state.careerTitle}
						</Typography>
					</Grid>
				</Grid>
				<Grid container={true} spacing={2} alignItems="flex-end">
					<Grid item={true} xs={12} md={2}>
						<Typography variant="subtitle1">
							{i18n.t('QuestionnaireList_0002')}
						</Typography>
					</Grid>
					<Grid item={true}>
						<Typography variant="h6">
							{this.props.match.params.class_id === 'CL000000'
								? i18n.t(this.state.classTitle, { ns: 'force' })
								: this.state.classTitle}
						</Typography>
					</Grid>
				</Grid>
				<Hidden xsDown={true}>
					<this.MainTable />
				</Hidden>
				<Hidden smUp={true}>
					<this.MainGrid />
				</Hidden>
				<MessageDialog
					open={this.state.openErrorStudyOrderMessageDialog}
					showCancelButton={false}
					title={i18n.t('QuestionnaireList_0021')}
					contents={[
						{
							content: this.state.errorStudyOrderdialogContent,
							replacements: this.state
								.errorStudyOrderdialogReplaceContent,
						},
					]}
					onClose={this.handleErrorMessageStudyOrderDialogClose}
					onClickOk={this.handleErrorMessageStudyOrderDialogClose}
				/>
			</div>
		);
	}

	/**
	 * テーブル作成
	 */
	protected MainTable: React.FC = props => (
		<Paper className={this.props.classes.paper}>
			<Typography variant="h6">
				{i18n.t('QuestionnaireList_0003')}
			</Typography>
			<Table>
				<colgroup>
					<col width={'25%'} />
					<col width={'10%'} />
					<col width={'35%'} />
					<col width={'18%'} />
					<col width={'12%'} />
				</colgroup>
				<TableHead>
					<TableRow>
						<TableCell size="small">
							{i18n.t('QuestionnaireList_0004')}
						</TableCell>
						<TableCell size="small">
							{i18n.t('QuestionnaireList_0005')}
						</TableCell>
						<TableCell size="small">
							{i18n.t('QuestionnaireList_0006')}
						</TableCell>
						<TableCell size="small">
							{i18n.t('QuestionnaireList_0007')}
						</TableCell>
						<TableCell size="small">
							{i18n.t('QuestionnaireList_0008')}
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{this.props.items.map(item => {
						const required = item.requiredFlg
							? i18n.t('QuestionnaireList_0009')
							: i18n.t('QuestionnaireList_0010');
						const status =
							item.iconClass === 'enquete-complete'
								? i18n.t('QuestionnaireList_0011')
								: i18n.t('QuestionnaireList_0012');
						let respondent;
						if (!item.expired) {
							respondent = (
								<Button
									variant="contained"
									color="primary"
									size="small"
									onClick={this.handleEnqueue(item)}
								>
									{i18n.t('QuestionnaireList_0013')}
								</Button>
							);
						} else {
							respondent = (
								<Button
									variant="contained"
									color="primary"
									size="small"
									disabled={true}
								>
									{i18n.t('QuestionnaireList_0014')}
								</Button>
							);
						}
						let answerPeriod = item.answerPeriod;
						if (answerPeriod && answerPeriod.indexOf('～') !== -1) {
							answerPeriod = answerPeriod.replace(
								'～',
								i18n.t('～', {
									ns: 'force',
								})
							);
						}
						return (
							<TableRow key={item.id}>
								<TableCell
									size="small"
									component="th"
									scope="row"
								>
									{item.text}
								</TableCell>
								<TableCell size="small">{required}</TableCell>
								<TableCell
									size="small"
									className={this.props.classes.tableCell}
								>
									{answerPeriod}
								</TableCell>
								<TableCell size="small">{status}</TableCell>
								<TableCell size="small">{respondent}</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</Paper>
	);

	protected handleEnqueue = (item: Actions.IQuestionnaire) => (
		e: React.MouseEvent<HTMLElement>
	) => {
		if (this.state.errorStudyOrderdialogContent !== '') {
			this.handleErrorMessageStudyOrderDialogOpen();
			return;
		}
		const flg = item.iconClass === 'enquete-complete' ? 1 : 0;
		let to = Routes.getPath(Screens.PERSONAL_QUESTIONNAIRE_FORM);
		to = to.replace(
			/\/:career_id\//,
			`/${this.props.match.params.career_id}/`
		);
		to = to.replace(
			/\/:class_id\//,
			`/${this.props.match.params.class_id}/`
		);
		to = to.replace(/\/:questionnaire_id\//, `/${item.id}/`);
		to = to.replace(/\/:type\//, `/${item.enqueteType}/`);
		to = to.replace(/\/:flg$/, `/${flg}`);
		this.props.pushHistory(to);
	};

	/**
	 * 回答ボタンエラーメッセージクローズ
	 */
	protected handleErrorMessageStudyOrderDialogClose = () => {
		this.setState({ openErrorStudyOrderMessageDialog: false });
	};

	/**
	 * 回答ボタンエラーメッセージオープン
	 */
	protected handleErrorMessageStudyOrderDialogOpen = () => {
		this.setState({ openErrorStudyOrderMessageDialog: true });
	};

	/**
	 * モバイル用一覧作成
	 */
	protected MainGrid: React.FC = props => (
		<>
			{this.props.items.map(item => {
				const required = item.requiredFlg
					? i18n.t('QuestionnaireList_0015')
					: i18n.t('QuestionnaireList_0016');
				const status =
					item.iconClass === 'enquete-complete'
						? i18n.t('QuestionnaireList_0017')
						: i18n.t('QuestionnaireList_0018');
				let respondent;
				if (!item.expired) {
					respondent = (
						<Button
							variant="contained"
							color="primary"
							size="small"
							onClick={this.handleEnqueue(item)}
						>
							{i18n.t('QuestionnaireList_0019')}
						</Button>
					);
				} else {
					respondent = (
						<Button
							variant="contained"
							color="primary"
							size="small"
							disabled={true}
						>
							{i18n.t('QuestionnaireList_0020')}
						</Button>
					);
				}
				let answerPeriod = item.answerPeriod;
				if (answerPeriod && answerPeriod.indexOf('～') !== -1) {
					answerPeriod = answerPeriod.replace(
						'～',
						i18n.t('～', {
							ns: 'force',
						})
					);
				}
				return (
					<Paper className={this.props.classes.paper} key={item.id}>
						<Typography variant="h6">{item.text}</Typography>
						<Typography variant="subtitle1">
							{required + ' / ' + status}
						</Typography>
						<Typography variant="caption" display="block">
							{answerPeriod}
						</Typography>
						<Typography variant="button" display="block">
							{respondent}
						</Typography>
					</Paper>
				);
			})}
		</>
	);
}

const mapStateToProps = (state: IRootState) => ({
	items: state.questionnaireList.items,

	distanceLearnings: state.imstat.onGoingDistanceLearning.data,
	eLearnings: state.imstat.onGoingELearning.data,
	groupTrainings: state.imstat.onGoingGroupTraining.data,

	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	clearQuestionnaireParams: () =>
		dispatch(Actions.clearQuestionnaireParams({})),
	doFetchOnGoingDistanceLearning: (token: string, userAttr: IUserAttr) => {
		const s = ImstatScenarioFactory.createDoFetchOnGoingDistanceLearning(
			dispatch,
			token
		);
		return s.run(userAttr);
	},
	doFetchOnGoingELearning: (token: string, userAttr: IUserAttr) => {
		const s = ImstatScenarioFactory.createDoFetchOnGoingELearning(
			dispatch,
			token
		);
		return s.run(userAttr);
	},
	doFetchOnGoingGroupTraining: (token: string, userAttr: IUserAttr) => {
		const s = ImstatScenarioFactory.createDoFetchOnGoingGroupTraining(
			dispatch,
			token
		);
		return s.run(userAttr);
	},
	doFetchResultDistanceLearning: (token: string, userAttr: IUserAttr) => {
		const s = ImstatScenarioFactory.createDoFetchResultDistanceLearning(
			dispatch,
			token
		);
		return s.run(userAttr);
	},
	doFetchResultGroupTraining: (token: string, userAttr: IUserAttr) => {
		const s = ImstatScenarioFactory.createDoFetchResultGroupTraining(
			dispatch,
			token
		);
		return s.run(userAttr);
	},
	fetchQuestionnaireList: (token: string, arg: IFetchQuestionnaireParam) => {
		const s = ScenarioFactory.createFetchQuestionnaire(dispatch, token);
		return s.run(arg);
	},
	pushHistory: (path: string) => dispatch(push(path)),
});

// tslint:disable-next-line: no-empty-interface
export interface IQuestionnaireListProps {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> &
	RouteComponentProps<IRouteParams, StaticContext, IRouteState> &
	IQuestionnaireListProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(QuestionnaireList);

const Styled = withStyles(styles)(Connected);
const Export: React.ComponentType<IQuestionnaireListProps> = Styled;

export default Export;



// WEBPACK FOOTER //
// ./src/containers/QuestionnaireList.tsx